import { render } from "./transferenciaLista.vue?vue&type=template&id=48661af2&scoped=true"
import script from "./transferenciaLista.vue?vue&type=script&lang=js"
export * from "./transferenciaLista.vue?vue&type=script&lang=js"

import "./transferenciaLista.vue?vue&type=style&index=0&id=48661af2&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48661af2"]])

export default __exports__